import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/segments/detail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* fetchSegmentDetail(action) {
  try {
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    // Get the segment ID from the action payload
    const segmentId = action.payload;
    
    if (!segmentId) {
      throw new Error('Segment ID is required');
    }
    
    // Make the API request to the correct endpoint
    const response = yield call(
      axios.get, 
      `${config.API_URL}/segment/${segmentId}`,
      { headers }
    );
    
    // Check if there's data in the response
    if (!response.data) {
      throw new Error('Invalid response from server');
    }
    
    // The new endpoint returns response with a segment property
    yield put(fetchSuccess(response.data.data?.segment || response.data.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetchSegmentDetail);
} 